import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { connect } from 'react-redux';

import { addLanguage, closeAddLanguageModal } from './actions';
import { METADATA_KEYS } from './utils';

const AddLanguageModal = ({
  show,
  onHide,
  availableLocales,
  onAdd,
}) => {
  const [language, setLanguage] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setLanguage('');
    setError('');
    onHide();
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setLanguage(value);
    const trimmed = value.trim();
    setError(
      trimmed && availableLocales.some((loc) => loc.toLowerCase() === trimmed.toLowerCase())
        ? 'This language already exists.'
        : '',
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = language.trim();
    if (!trimmed || error) return;
    onAdd(trimmed);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title>Add Language</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group controlId="language">
            <Form.Label>Language</Form.Label>
            <Form.Control
              type="text"
              value={language}
              onChange={handleChange}
              isInvalid={!!error}
              placeholder="e.g. french"
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" size="sm" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" size="sm" type="submit" disabled={!language.trim() || !!error}>
            Add
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default connect(
  (state) => {
    const rows = state.aiTemplateLanguages.languageRows;
    const locales = new Set();
    rows.forEach((row) => {
      Object.keys(row).filter((k) => !METADATA_KEYS.includes(k)).forEach((k) => locales.add(k));
    });
    return {
      show: state.aiTemplateLanguages.isAddLanguageModalOpen,
      availableLocales: [...locales].sort((a, b) => a.localeCompare(b)),
    };
  },
  {
    onHide: closeAddLanguageModal,
    onAdd: addLanguage,
  },
)(AddLanguageModal);
